"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.acceptFormFocusableClassname = exports.focusFirstAcceptFlowElement = exports.templateGalleryDisabledMessage = exports.collaboratorDisabledMessage = exports.mapPrefillData = exports.getShouldSkipOptionalPayment = exports.getPaymentDetails = exports.transformAndCleanFormData = void 0;
var CleanJson_1 = __importDefault(require("@CommonFrontend/CleanJson/CleanJson"));
var lodash_1 = require("lodash");
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var transformAndCleanFormData = function (formData, settings, prefillData) {
    var acceptanceData;
    if (settings.customForm) {
        var customDetailsKeys = settings.customForm.fields.map(function (field) { return field.id; });
        acceptanceData = (0, lodash_1.omit)(formData, customDetailsKeys);
        var customForm = settings.customForm.fields.map(function (field) {
            var _a, _b;
            return {
                id: field.id,
                field: field.name,
                value: (_b = (_a = formData[field.id]) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "",
            };
        });
        acceptanceData.customFormId = settings.customForm.id;
        acceptanceData.customForm = (0, CleanJson_1.default)(customForm);
        acceptanceData.usedCustomForm = true;
    }
    else {
        acceptanceData = formData;
    }
    if (prefillData && prefillData.name) {
        acceptanceData.isPrefilled = prefillData.name.source === "blockSettings";
    }
    else {
        acceptanceData.isPrefilled = false;
    }
    acceptanceData = (0, lodash_1.omit)(acceptanceData, ["cardName", "cardZip", "cardNumber", "cardCvc", "cardExpiry"]);
    return acceptanceData;
};
exports.transformAndCleanFormData = transformAndCleanFormData;
var getPaymentDetails = function (payNowSettings, projectCurrencies, quoteTotal) {
    var getCurrencyCode = function () {
        try {
            return projectCurrencies.getSingleCurrency();
        }
        catch (error) {
            return "AUD";
        }
    };
    var getPayNowAmount = function () {
        if (quoteTotal == null) {
            return 0;
        }
        if (payNowSettings.enablePartPayment) {
            if (payNowSettings.partPaymentPercentage) {
                var percentage = Math.max(Math.min(payNowSettings.partPaymentPercentage, 100), 0.1);
                return (quoteTotal * percentage) / 100;
            }
            if (payNowSettings.partPaymentType === "percentage" && payNowSettings.partPaymentAmount) {
                var percentage = Math.max(Math.min(payNowSettings.partPaymentAmount, 100), 0.1);
                return (quoteTotal * percentage) / 100;
            }
            if (payNowSettings.partPaymentAmount) {
                return Math.min(payNowSettings.partPaymentAmount, quoteTotal);
            }
        }
        return quoteTotal;
    };
    return {
        currencyCode: getCurrencyCode(),
        payNowAmount: getPayNowAmount(),
        isPartial: payNowSettings.enablePartPayment,
    };
};
exports.getPaymentDetails = getPaymentDetails;
var getShouldSkipOptionalPayment = function (formValues, payNowSettings) {
    var _a, _b;
    var isStripeFieldEmpty = function (stripeFieldId) {
        var value = formValues[stripeFieldId];
        if (typeof value === "undefined") {
            return true;
        }
        if (typeof value !== "object") {
            throw new Error("Stripe field doesn't have an object value");
        }
        if (value instanceof Array) {
            throw new Error("Stripe field has an array value");
        }
        return !!value.isEmpty;
    };
    return (payNowSettings.enableOptionalPayment &&
        isStripeFieldEmpty("cardNumber") &&
        isStripeFieldEmpty("cardCvc") &&
        isStripeFieldEmpty("cardExpiry") &&
        !((_a = formValues["cardName"]) === null || _a === void 0 ? void 0 : _a.toString()) &&
        !((_b = formValues["cardZip"]) === null || _b === void 0 ? void 0 : _b.toString()));
};
exports.getShouldSkipOptionalPayment = getShouldSkipOptionalPayment;
var mapPrefillData = function (_a) {
    var springboardData = _a.springboardData, blockSettings = _a.blockSettings;
    var name = (blockSettings === null || blockSettings === void 0 ? void 0 : blockSettings.name)
        ? { value: blockSettings.name, source: "blockSettings" }
        : (springboardData === null || springboardData === void 0 ? void 0 : springboardData.legalName)
            ? { value: springboardData.legalName, source: "springboard" }
            : undefined;
    if (springboardData) {
        var data = __assign(__assign(__assign(__assign({}, (0, CommonUtils_1.includeIf)(!!(springboardData === null || springboardData === void 0 ? void 0 : springboardData.email), {
            email: { value: springboardData.email, source: "springboard" },
        })), (0, CommonUtils_1.includeIf)(!!(springboardData === null || springboardData === void 0 ? void 0 : springboardData.signature), {
            esignature: { value: springboardData.signature, source: "springboard" },
        })), (0, CommonUtils_1.includeIf)(!!(springboardData === null || springboardData === void 0 ? void 0 : springboardData.organisation), {
            legalEntity: { value: springboardData.organisation, source: "springboard" },
        })), (0, CommonUtils_1.includeIf)(!!name, { name: name }));
        return data;
    }
    return __assign({}, (0, CommonUtils_1.includeIf)(!!name, { name: name }));
};
exports.mapPrefillData = mapPrefillData;
exports.collaboratorDisabledMessage = "This page is for internal collaboration only - use the Shareable Link to allow clients to accept";
exports.templateGalleryDisabledMessage = "Cannot accept a template page.";
var focusFirstAcceptFlowElement = function () {
    var firstFocusable = document.getElementsByClassName(exports.acceptFormFocusableClassname)[0];
    if (firstFocusable) {
        var wrappedInput = firstFocusable.querySelector("input");
        var elementToFocus = !!wrappedInput ? wrappedInput : firstFocusable;
        elementToFocus.focus({ preventScroll: true });
    }
};
exports.focusFirstAcceptFlowElement = focusFirstAcceptFlowElement;
exports.acceptFormFocusableClassname = "accept-form-focusable";
